import redClubPoints from 'assets/images/redClubPoints.svg'
import handWithStar from 'assets/images/handWithStar.png'
import basketballPlayer from 'assets/images/basketballPlayer.png'
import discount from 'assets/images/discount.png'
import {
  StyledAdvantageImg,
  StyledAdvantageTitle,
  StyledFanAdvantagesContainer,
  StyledPointsOptionsSection1,
  StyledPointsOptionsSection2,
  StyledPointsSection,
  StyledRedClubContentContainer,
  StyledRedClubFanSection,
  StyledSectionContainer,
  StyledTabContentTitle,
  StyledWayOfPointsTitle,
} from './styles'
import { useTranslation } from 'react-i18next'

export const TheRedClub = () => {
  const { t } = useTranslation('', {
    keyPrefix: 'pages.personalArea.tabs.theRedClub',
  })
  return (
    <StyledRedClubContentContainer>
      <StyledRedClubFanSection className="red-club-fan">
        <StyledSectionContainer>
          <StyledTabContentTitle>
            {t('beingRedClubFan.title')}
          </StyledTabContentTitle>
          <StyledFanAdvantagesContainer>
            {redClubData.beingRedClubFan.advantagesArr.map((advantage) => {
              return (
                <div key={advantage.desc}>
                  <StyledAdvantageImg src={advantage.img} alt={advantage.img} />
                  <StyledAdvantageTitle>
                    {t(advantage.desc)}
                  </StyledAdvantageTitle>
                </div>
              )
            })}
          </StyledFanAdvantagesContainer>
        </StyledSectionContainer>
      </StyledRedClubFanSection>
      <StyledPointsSection className="how-to-points">
        <StyledTabContentTitle>{t('howToPoints.title')}</StyledTabContentTitle>
        <StyledPointsOptionsSection1>
          {redClubData.howToPoints.firstWaysArr.map((howTo, index) => {
            return (
              <div key={index}>
                <img src={redClubPoints} alt="club-points-logo" />
                <StyledWayOfPointsTitle>{t(howTo.way)}</StyledWayOfPointsTitle>
              </div>
            )
          })}
        </StyledPointsOptionsSection1>
        <StyledPointsOptionsSection2>
          {redClubData.howToPoints.secondWaysArr.map((howTo, index) => {
            return (
              <div key={index}>
                <img src={redClubPoints} alt="club-points-logo" />
                <StyledWayOfPointsTitle>{t(howTo.way)}</StyledWayOfPointsTitle>
              </div>
            )
          })}
        </StyledPointsOptionsSection2>
      </StyledPointsSection>
    </StyledRedClubContentContainer>
  )
}

export default TheRedClub

const redClubData = {
  beingRedClubFan: {
    title: 'beingRedClubFan.title',
    advantagesArr: [
      {
        desc: 'beingRedClubFan.advantagesArr.pointAccumulation',
        img: handWithStar,
      },
      {
        desc: 'beingRedClubFan.advantagesArr.gameActivities',
        img: basketballPlayer,
      },
      {
        desc: 'beingRedClubFan.advantagesArr.exclusiveDiscounts',
        img: discount,
      },
    ],
  },
  howToPoints: {
    title: 'howToPoints.title',
    firstWaysArr: [
      { way: 'howToPoints.firstWaysArr.seasonTicket' },
      { way: 'howToPoints.firstWaysArr.earlyGameArrival' },
      { way: 'howToPoints.firstWaysArr.storePurchase' },
    ],
    secondWaysArr: [
      { way: 'howToPoints.secondWaysArr.homeGame' },
      { way: 'howToPoints.secondWaysArr.awayGame' },
    ],
  },
}
